import type { Response } from '../response';
import type { Contact } from '../../ontology/admin';
import { post } from '../fetch-extension';

export default async function postContact(payload: Contact): Promise<Response<any>> {
    const { error, result } = await post(`admin/contact_message`, { body: payload });

    if (error) {
        return { error };
    }

    return { result: result };
}


